import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfile } from '../models/UserProfile';
import { UserProfileForCreation } from '../models/UserProfileForCreation';
import { BaseService } from './base.service';
import { EventsService } from './events.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class UserProfileService extends BaseService {

  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService,
    private eventsService: EventsService) {
    super();
  }
  private readonly CURRENT_USER_NAME = 'current-user-name'; 
    
  get currentUserName(): string {
    return localStorage.getItem(this.CURRENT_USER_NAME) as string;
  }

  set currentUserName(currentUserName: string) {
    if(currentUserName){
      localStorage.setItem(this.CURRENT_USER_NAME, currentUserName);
    }
    else{
      localStorage.removeItem(this.CURRENT_USER_NAME);
    }
    this.eventsService.currentUserNameChanged.emit(currentUserName);
  }


  getUser(): Observable<UserProfileForCreation> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserProfileForCreation>(`${this.userprofiles}/GetUser`, { headers: headers });
  }

  getUserById(id: any): Observable<UserProfileForCreation> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserProfileForCreation>(`${this.userprofiles}/GetUserById/${id}`, { headers: headers });
  }

  getUsersByIds(ids: any[]): Observable<UserProfileForCreation[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<UserProfileForCreation[]>(`${this.userprofiles}/GetUsersByIds`, ids, { headers: headers });
  }

  getUsers(): Observable<UserProfileForCreation[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserProfileForCreation[]>(`${this.userprofiles}`, { headers: headers });
  }

  addProfile(profile: UserProfileForCreation): Observable<UserProfileForCreation> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<UserProfileForCreation>(`${this.userprofiles}/CreateProfile`, profile, { headers: headers });
  }

  updateProfileById(id: any, profile: UserProfileForCreation): Observable<UserProfileForCreation> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<UserProfileForCreation>(`${this.userprofiles}/UpdateProfileById/${id}`, profile, { headers: headers });
  }

  addUserProfile(newUser: any): Observable<any> {
    console.log(newUser);
    return this.httpClient.post<any>(`${this.account}`, newUser);
  }

  sendEmail(email: string) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    headers.set('Content-Type', 'application/json');
    // return this.httpClient.post<string>(`${this.userprofiles}/SendVerificationEmail?email=${email}`, JSON.stringify(email), { headers: { 'Content-Type': 'application/json' } });
    return this.httpClient.post<string>(`${this.userprofiles}/SendVerificationEmail?email=${email}`, JSON.stringify(email), { headers: headers });
  }

}
